import { useEffect, useState } from "react";

import { getSyncStatus, subscribeSyncStatus } from "src/handlers/syncStatus";

// React wrapper over the global sync status.
// Returns the latest `{ status, pending, lastSavedAt, lastError }`.
export default function useSyncStatus() {
  const [snapshot, setSnapshot] = useState(() => getSyncStatus());

  useEffect(() => subscribeSyncStatus(setSnapshot), []);

  return snapshot;
}
